<template lang="pug">
.hubspot
  ManagementPage(:title="$t(`${baseTranslationPath}.title`)"
                :info="$t(`${baseTranslationPath}.description`)"
                :creatable="false"
                :searchable="false")

  .hubspot-config(v-if="this.config !== null")
    aiq-col.padding-10(:span="12")
      shared-auth-config(:name='name'
                         :config="config"
                         :title="$t(`${baseTranslationPath}.oauth_title`)"
                         @update="onChange")

      aiq-row.padding-10(:span="12")
        aiq-button.save__button(type="primary"
                              :disabled="isConnecting"
                              @click="saveAndConnect")
          span {{ $t(`${baseTranslationPath}.connect`) }}
          hub-spot-oauth(v-if="isConnecting"
                              :auth-config="config.oauth"
                              @auth-success="onAuthSuccess"
                              @auth-failure="onAuthFailure")

</template>

<script>
import * as log from 'loglevel';
import SharedAuthConfig from '../SharedAuthConfig.vue';
import ManagementPage from '@/components/ManagementPage/ManagementPage.vue';
import HubSpotOauth from './HubSpotOauth.vue';

export default {
  name: 'HubSpotTab',
  components: {
    SharedAuthConfig,
    ManagementPage,
    HubSpotOauth,
  },
  computed: {
    name() {
      return 'hubspot';
    },
    baseTranslationPath() {
      return 'settings_tab.integraions_tab.hubspot';
    },
  },
  data() {
    return {
      config: null,
      isConnecting: false,
    };
  },
  async mounted() {
    try {
      this.config = await this.$store.dispatch('integrations/getIntegration', { name: this.name });
    } catch (err) {
      this.$aiq.notify.error(`Failed to load integration config: ${err.message}`);
      log.error(err);
    }
  },
  methods: {
    async onUpdate(newConfig) {
      try {
        this.config = await this.$store.dispatch('integrations/updateIntegration', {
          name: this.name,
          payload: newConfig,
        });
        this.$aiq.notify.success('Updated');
      } catch (err) {
        this.$aiq.notify.error(`Failed: ${err.message}`);
      }
    },
    async onChange(subObject) {
      await this.onUpdate({ ...this.config, ...subObject });
    },

    async onEnabled(enabled) {
      await this.onUpdate({ ...this.config, enabled });
    },

    async saveAndConnect() {
      this.isConnecting = true;
    },

    onAuthFailure() {
      this.$aiq.notify.error('Authentication Failed');
      this.isConnecting = false;
    },

    onAuthSuccess() {
      this.isConnecting = false;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
